<!-- 留言评论 -->
<template>
	<div class="com-leave-word-wp">
		<div v-if="source=='BZZX'" style="width:100%;height:40px;">
			<p style="float:left;">售后评分：</p><el-rate v-model="stars" style="width:200px;float:left;"></el-rate>
		</div>
		
		<el-input v-model="form.msg" class="this-ipt" type="textarea" placeholder="我的留言内容" resize="none" rows="5"></el-input>
		<div class="text-right">
			<el-button type="primary" @click="sendReply()">我要留言</el-button>
		</div>
		<div class="wrapper-box">
			<div class="reply-list">
				<div v-for="(aItem, aIndex) in list" :key="aIndex" class="item lv1">
					<div class="this-ct">
						<img src="../assets/image/home/leave-message.png">
						<div class="ct">
							<div class="text-box">
								<span class="name">{{aItem.nickName}}</span>
								<span>：</span>
								<span>{{aItem.msg}}</span>
							</div>
							<el-rate v-if="source=='BZZX'" v-model="aItem.pf" disabled style="width:100%;float:left;"></el-rate>
							<div class="handle-box">
								<div class="box1">
									<span class="reply-btn" v-if="aItem.type==0" @click="aItem.isreply = !aItem.isreply">{{aItem.isreply ? '收起' : '回复'}}</span><span v-if="aItem.type==0">·</span><span :class="{time:aItem.type==0}">{{aItem.createDate}}</span>
									<span v-if="aItem.children.length" class="show-btn" @click="aItem.showList = !aItem.showList">{{aItem.showList ? '收起' : '展开'}}评论</span>
								</div>
								<div class="ipt-box" :class="{show: aItem.isreply}">
									<el-rate v-if="source=='BZZX'" v-model="stars" style="width:200px;float:left;"></el-rate>
									<el-input v-model="aItem.replyText" class="ipt" type="text" placeholder="撰写回复"></el-input>
									<div class="text-right">
										<el-button size="small" type="primary" @click="sendReply(aItem)">我要留言</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<el-collapse-transition>
						<div v-show="aItem.showList" class="reply-list">
							<div v-for="(bItem, bIndex) in aItem.children" :key="aIndex+ '_' + bIndex" class="item">
								<div class="this-ct">
									<div class="floor">{{bIndex + 1}}楼</div>
									<div class="ct">
										<div class="text-box">
											<span class="name">{{bItem.nickName}}</span>
											<span>：</span>
											<span class="reply-name">{{bItem.touser}}</span>
											<span>{{bItem.msg}}</span>
										</div>
										<div class="handle-box">
											<div class="box1">
												<span class="reply-btn" v-if="bItem.type==0" @click="bItem.isreply = !bItem.isreply">{{bItem.isreply ? '收起' : '回复'}}</span><span v-if="bItem.type==0">·</span><span :class="{time:bItem.type==0}">{{bItem.createDate}}</span>
											</div>
											<div class="ipt-box" :class="{show: bItem.isreply}">
												<el-rate v-if="source=='BZZX'" v-model="stars" style="width:200px;float:left;"></el-rate>
												<el-input v-model="bItem.replyText" class="ipt" type="text" placeholder="撰写回复"></el-input>
												<div class="text-right">
													<el-button size="small" type="primary" @click="sendReply(bItem)">我要留言</el-button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</div>
			<div class="page-box">
				<z-page :pageObj="page" @changePage1="changePage"></z-page>
			</div>
		</div>
			
	</div>
</template>
<script>
	
import zPage from '@/views/Page/page.vue';
import {isLogin} from '../assets/js/tools.js';
export default {
	name: 'comLeaveWord',
	data () {
		return {
			page:{
              targetPage:1,
              pageSize:10,
              totalPage:0,
              type:2,
            },

            form: {
            	msg: '', // 留言内容
            },

			list: [], // 留言列表
			stars:0,
		}
	},
	props: ['chatId', 'source'],
	components: {
		zPage,
	},
	mounted () {
		this.getData();
	},
	methods: {
		getData () {
			var param = {
				pageNumber: this.page.targetPage-1,
				pageSize: this.page.pageSize,
				source: this.source,
				id:this.chatId,
			}
			this.get(this.api.getMsg, param).then(res => {
				if (res.result == 200) {
					this.getList(res.data.list);
					this.page.totalPage = res.data.totalElements;
				}
			})
		},

		// 撰写回复
		sendReply (pItem, aIdx, bIdx) {
			// if(!isLogin()){
			// 	return;
			// }
			var param = {
				chatId: this.chatId,
				source: this.source,
			}
			if(this.source=='BZZX'){
				param.stars=this.stars;
			}
			// 创建根留言
			if (!pItem) {
				param.msg = this.form.msg;
				if(this.form.msg.length>1000){
					this.$message.warning('留言内容为1000个字符以内');
					return;
				}

			// 创建子留言
			} else {
				param.msg = pItem.replyText;
				param.pid = pItem.id;
				if(pItem.replyText.length>200){
					this.$message.warning('回复内容为200个字符以内');
					return;
				}
			}
			if (!('' + param.msg).length) {
				this.$message.error('请输入留言内容');
				return;
			}

			this.post(this.api.addMsg, param).then(res => {
				if (res.result == 200) {
					this.$message.success('发布留言成功');

					if (!pItem) {
						this.form.msg = '';
					} else {
						pItem.replyText = '';
					}
					this.getData();
				}
			})
		},

		// 通过留言树获取列表
		getList (data) {
			this.list=[];
			var list = [];

			// 1. 获取一级留言
			for (let i = 0; i < data.length; i++) {
				let item = data[i];
				let obj = {
					id: item.id,
					nickName: item.nickName,
					createDate: item.createDate,
					msg: item.msg,
					pf:item.pf,
					type: item.type,
					type_text: item.type_text,
					children: [],
					isreply: false, // 是否显示留言输入框
					replyText: '', // 留言内容
					showList: false, // 显示留言评价列表
				}
				
				// 将留言树都放到children中
				if (item.dtos && item.dtos.length) {
					recursion(item.dtos, obj.children);
				}
				list.push(obj);
			}

			// 2. 根据时间排序
			list.sort((prev, next) => {
				var prevTime = new Date(prev.createDate).getTime(),
					nextTime = new Date(next.createDate).getTime();
				return prevTime > nextTime ? 1 : -1;
			})
			for (let i = 0; i < list.length; i++) {
				let aItem = list[i];
				
				aItem.children.sort((prev, next) => {
					var prevTime = new Date(prev.createDate).getTime(),
						nextTime = new Date(next.createDate).getTime();
					return prevTime > nextTime ? 1 : -1;
				})
			}

			// 3. 设置回复的楼层
			for (let i = 0; i < list.length; i++) {
				let aItem = list[i];
				
				for (let j = 0; j < aItem.children.length; j++) {
					let bItem = aItem.children[j];

					if (bItem.pid == aItem.id) {
						bItem.touser = `@ ${aItem.nickName}`;
					} else {

						for (let z = 0; z < aItem.children.length; z++) {
							let cItem = aItem.children[z];
							if (bItem.pid == cItem.id) {
								bItem.touser = `@ ${z+1}楼 ${cItem.nickName}`;
								break;
							}
						}
					}
				}
			}

			// 4. 将新列表添加的录入旧列表，不直接添加
			
			if (this.list.length) {
				console.log(1);
				for (let i = 0; i < this.list.length; i++) {
					let aItem = this.list[i];
					let bItem = list[i];
					if (bItem.children.length > aItem.children.length) {
						let arr = bItem.children.slice(aItem.children.length);
						aItem.children = aItem.children.concat(arr);
					}
				}
				if (list.length > this.list.length) {
					let arr = list.slice(this.list.length);
					this.list = this.list.concat(arr);
				}
			} else {
				this.list = list;
			}
			

			// 将留言树都放到children中
			function recursion (arr, children) {
				for (let i = 0; i < arr.length; i++) {
					let item = arr[i];
					children.push({
						id: item.id,
						pid: item.pid,
						nickName: item.nickName,
						createDate: item.createDate,
						msg: item.msg,
						type: item.type,
						type_text: item.type_text,
						isreply: false, // 是否显示留言输入框
						replyText: '', // 留言内容
						touser: '', // 给谁留的言
					})
					if (item.dtos && item.dtos.length) {
						recursion(item.dtos, children);
					}
				}
			}
		},

	}
}	
</script>
<style lang="scss" scoped>
.com-leave-word-wp {
	.this-ipt {
		margin-bottom: 10px;
	}

	.wrapper-box {
		padding-top: 20px;
		.reply-list {
			.item {
				&.lv1 {
					& > .this-ct {
						img {
							display: block;
							margin-right: 20px;
							width: 40px;
							height: 40px;
							border-radius: 50%;
						}
						.ct {
							.text-box {
								font-size: 18px;
								line-height: 30px;
							}
						}
					}
				}
				.this-ct {
					display: flex;
					justify-content: space-between;
					padding-bottom: 10px;
					img {
						display: none;
					}
					.floor {
						padding-right: 15px;
						line-height: 26px;
					}
					.ct {
						flex: 1;
						.text-box {
							line-height: 26px;
							font-size: 16px;
							.name {
								color: #178AF2;
								font-weight: 600;
							}
							.reply-name {
								margin-right: 10px;
								color: #178AF2;
							}
						}

						.handle-box {
							color: #6c757d;
							.box1 {
								padding: 10px 0;
								.reply-btn {
									margin-right: 10px;
									cursor: pointer;
								}
								.time {
									margin-left: 10px;
								}
								.show-btn {
									margin-left: 20px;
									cursor: pointer;
								}
								.reply-btn:hover, .show-btn:hover {
									color: #494f54;
								}
							}
							.ipt-box {
								display: none;
								padding: 20px;
								background: #eee;
								.ipt {
									margin-bottom: 10px;
								}
								&.show {
									display: block;
								}
							}
						}
					}
				}
				& > .reply-list {
					margin-left: 60px;
					padding: 10px;
					background: #eee;
				}
			}
		}
		.page-box {
			padding-top: 20px;
		}
	}
}
</style>






